import { render, staticRenderFns } from "./assetlistga.vue?vue&type=template&id=46c95bfe"
import script from "./assetlistga.vue?vue&type=script&lang=js"
export * from "./assetlistga.vue?vue&type=script&lang=js"
import style0 from "./assetlistga.vue?vue&type=style&index=0&id=46c95bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports